import React, { Component } from 'react';
import * as Config from '../config/Config';
import * as Common from '../helpers/Common';
import Seeknotes from './notepad_partials/Seeknotes';
import Sharenotes from './notepad_partials/Sharenotes';
import Allnotes from './notepad_partials/Allnotes';
import ShareRequests from './notepad_partials/ShareRequests';


const $=window.$;
const win=window;
const jQuery=window.jQuery;

class Notes extends Component {

    constructor(props) {
        super(props);
        this.state={
            buddies:[],
            allnotes:[],
            share_request : [],
            seeknotes:[],
            sharenotes:[]
        };

    }
    onchangedStatus(status){
        if(status == 'changed'){
            this.getNotesListInfo();
        }
    }

    getNotesListInfo(){

        let learnerID   = Common.getUserData("id", true);       
        let pinID 		= Common.getUserData("pinID", true);       
        let productID 	= Common.getUserData("productID", true);  
        let pinNo 	= Common.getUserData("pinNo", true);  
        let corporateID 	= Common.getUserData("corporateID", true);  

        fetch(Config.domainUrl+'writing-pad/get-notes-list', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization':'Bearer ' +Common.getTokenData()
            },
            body: JSON.stringify({
                learner_id: learnerID,
                pinID: pinID,
                productID:productID,
                pinNo:pinNo,
                corporateID:corporateID
            })
            }).then((response) => response.json()).then((responseJson) => {
                let data=responseJson.data;

                if(responseJson.status==1){
                    this.setState({
                        buddies:data.buddies,
                        allnotes:data.mynotes,
                        seeknotes:data.seek_notes,
                        sharenotes:data.share_notes,
						share_request : data.share_request
                        })
                }
                                 
                        
            });
    }
    componentDidMount(){
        const {type}=this.props;
        let selector="#parentHorizontalTab";
        $('.modal-overlay').hide();
        $(selector).easyResponsiveTabs({
            type: 'default', //Types: default, vertical, accordion
            width: 'auto', //auto or any width like 600px
            fit: true, // 100% fit in a container
            //closed: 'accordion', // Start closed if in accordion view
            tabidentify: 'hor_1', // The tab groups identifier
            activate: function (event) { // Callback function if tab is switched

                // var $tab = $(this);
                // var $info = $('#nested-tabInfo');
                // var $name = $('span', $info);

                // $name.text($tab.text());

                // $info.show();
            }
        });
        let activateTab=0;
        switch (type) {
            case 'seek_notes':
                activateTab=1;                
            break;
            case 'sharek_notes':
            activateTab=2;                
            break;
            case 'share_requests':
            activateTab=3;                
            break;
            case 'all_notes':
            activateTab=4;                
            break;
        }
        
        setTimeout( "$('"+selector+" ul.resp-tabs-list li:nth-child("+activateTab+")').trigger('click');",200 );

        this.getNotesListInfo();
        
    }
    render () {
       
        return (
            <section id="contentsection" className="contentarea">
                <div className="inner-title-bg journey-tit-bg">
					        <h1>
                                <span><img src={process.env.PUBLIC_URL+"/images/img-myobserver.jpg"} align="absmiddle" alt="" border="0"/>
                                    </span>Notes<br/>
                                <span className="subtitle">Share & seek collection of notes prepared by you an your friends.</span> 
                            </h1>
					     </div>

              <div className="myperformance myobservers seeknotestab">
                    <section id="semana-scroll-inner" className="scroll">                      
                        <section className="viewport">
                            <section className="overview">
                                <div className="inner-content">                         
                                    <div id="parentHorizontalTab">
                                        <ul className="resp-tabs-list hor_1 horizontaltabbg">

                                        <li>Seek Notes
                                                <div className="activearrow"><img src={process.env.PUBLIC_URL+"/images/activetab.png"} border="0"/></div>
                                            </li>
                                            <li>Share Notes
                                                <div className="activearrow"><img src={process.env.PUBLIC_URL+"/images/activetab.png"} border="0"/></div>
                                            </li>
                                            <li>Share Requests
                                                <div className="activearrow"><img src={process.env.PUBLIC_URL+"/images/activetab.png"} border="0"/></div>
                                            </li>
                                            <li> All Notes
                                                <div className="activearrow"><img src={process.env.PUBLIC_URL+"/images/activetab.png"} border="0"/></div>
                                            </li>

                                        </ul>

                                        <div className="resp-tabs-container hor_1 tapmargntop">
                                          <div className="tab-content">                                           
                                                <Seeknotes data={this.state.seeknotes} changedStatus={this.onchangedStatus.bind(this)}/>
                                            </div>
                                            <div className="tab-content">
                                                <Sharenotes data={this.state.sharenotes} changedStatus={this.onchangedStatus.bind(this)}/>
                                            </div>
                                            <div className="tab-content">
                                                <ShareRequests shareData={this.state.share_request} changedStatus={this.onchangedStatus.bind(this)}/>
                                            </div>
                                            <div className="tab-content">
                                            <Allnotes data={this.state.allnotes} buddies={this.state.buddies} />                                               
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </section>
                        </section>
                        </section>
                </div>    
            </section>
        )
    }
}
export default Notes


// WEBPACK FOOTER //
// ./src/lr_dlr_components/Notes.js